module.exports = __webpack_public_path__ + "img/Vegetable-Lasagna-2.fa0fec29.jpg";